module.exports = __webpack_public_path__ + "static/img/top1.01be3f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/top1.png
// module id = MWYe
// module chunks = 0